import { styled } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Button';
import { CircularLoader } from '../CircularLoader';
import { ArrowRightIcon } from '../Icons';
import { CalculatorSubmitButtonProps } from './types';

const StyledButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    backgroundColor: theme.colors.main,
    color: theme.colors.white,
    fontSize: '1rem',
    margin: 0,
    display: 'flex',
    borderRadius: '5rem',
    padding: '0.8rem 3rem',
    fontWeight: 900,
    textTransform: 'none',

    '.arrow': {
      marginLeft: '0.8rem',
    },
  },
}));

export const CalculatorSubmitButton: FC<CalculatorSubmitButtonProps> = ({
  onClick = () => ({}),
  textKey = 'common.saveContinue',
  buttonType = 'button',
  isLoading = false,
  circularProgressProps,
  circularProgressClassName,
}) => (
  <StyledButton type={buttonType} onClick={onClick} disabled={isLoading}>
    {isLoading ? (
      <div className={circularProgressClassName}>
        <CircularLoader size={28} color={'inherit'} {...circularProgressProps} />
      </div>
    ) : (
      <>
        <FormattedMessage id={textKey} />
        <ArrowRightIcon className={'arrow'} />
      </>
    )}
  </StyledButton>
);
